export default __webpack_public_path__ + "static/media/box.d66007d4.svg";